module.exports = __webpack_public_path__ + "img/adas-hil-7.39a88105.svg";